/**
 * Canais incluídos no plano (`limits.whatsapp_connections`). Mesma regra do backend
 * (`included-channels.ts`): inteiro de 0 a 100000; ausente ou inválido vale 1.
 */
export function includedChannels(limits?: Record<string, number> | null): number {
  const value = limits?.whatsapp_connections;
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 100000 ? value : 1;
}
